/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // Mobile slider progress bar
  function initSliderProgress() {
    document.querySelectorAll('.grid--mobile-slider').forEach(function(slider) {
      if (slider.dataset.progressInit) return;
      var items = slider.querySelectorAll(':scope > .grid-item');
      if (items.length <= 1) return;

      slider.dataset.progressInit = 'true';

      var track = document.createElement('div');
      track.className = 'mobile-slider-progress';
      var bar = document.createElement('div');
      bar.className = 'mobile-slider-progress__bar';
      track.appendChild(bar);
      slider.parentElement.insertBefore(track, slider.nextSibling);

      var updateBar = function() {
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        if (maxScroll <= 0) return;
        var ratio = slider.clientWidth / slider.scrollWidth;
        var trackWidth = track.offsetWidth;
        var barWidth = Math.max(40, ratio * trackWidth);
        var maxBarLeft = trackWidth - barWidth;
        var position = slider.scrollLeft / maxScroll;
        bar.style.width = barWidth + 'px';
        bar.style.left = (position * maxBarLeft) + 'px';
      };

      updateBar();
      slider.addEventListener('scroll', updateBar);
    });
  }

  document.addEventListener('DOMContentLoaded', initSliderProgress);
  document.addEventListener('shopify:section:load', initSliderProgress);

// VO Product Options: Validate required fields before Broadcast's form handler
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form.matches('form[data-product-form]')) return;

  var productInfo = form.closest('product-info');
  if (!productInfo) return;

  var voFields = productInfo.querySelectorAll('.bcpo-front-button-option[required], input[name*="properties"][required], select[name*="properties"][required], textarea[name*="properties"][required]');
  var hasEmpty = false;

  voFields.forEach(function(field) {
    if (field.type === 'radio') {
      var group = productInfo.querySelectorAll('input[name="' + field.name + '"]');
      var anyChecked = false;
      group.forEach(function(r) { if (r.checked) anyChecked = true; });
      if (!anyChecked) hasEmpty = true;
    } else if (field.value.trim() === '') {
      hasEmpty = true;
    }
  });

  // Remove any previous error message
  var existing = productInfo.querySelector('.vo-validation-error');
  if (existing) existing.remove();

  if (hasEmpty) {
    e.preventDefault();
    e.stopImmediatePropagation();

    // Show error message above the Add to Cart button
    var submitButton = form.querySelector('[data-add-to-cart]');
    if (submitButton) {
      var errorDiv = document.createElement('div');
      errorDiv.className = 'vo-validation-error';
      errorDiv.textContent = 'Please fill in all required customization options above.';
      errorDiv.style.cssText = 'color: #c00; font-size: 14px; margin-bottom: 10px; padding: 8px; text-align: center;';
      submitButton.closest('.product__submit__buttons').insertBefore(errorDiv, submitButton.closest('.product__submit__item'));
    }
  }
}, true);

  /**
   * Fix: VO Product Options properties not passing to cart in "Theme Default" mode.
   *
   * VO renders its inputs (embroidery text, location, thread color) in its own
   * form, separate from Broadcast's product form. When the theme creates FormData
   * from its form, VO's properties are excluded. This fix copies VO's property
   * values into the theme form just before Broadcast serializes it.
   */
  (function() {
    document.addEventListener('theme:cart:add', function(evt) {
      var button = evt.detail && evt.detail.button;
      if (!button) return;

      var themeForm = button.form || button.closest('form');
      if (!themeForm) return;

      // Remove any previously injected inputs (from prior add-to-cart)
      var stale = themeForm.querySelectorAll('.vo-injected-property');
      for (var i = 0; i < stale.length; i++) stale[i].remove();

      // Copy VO's property inputs into the theme form
      var allProps = document.querySelectorAll('[name*="properties["]');
      for (var j = 0; j < allProps.length; j++) {
        var input = allProps[j];
        if (themeForm.contains(input)) continue;
        if (input.type === 'radio' && !input.checked) continue;
        if (input.type === 'checkbox' && !input.checked) continue;

        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = input.name;
        hidden.value = input.value;
        hidden.className = 'vo-injected-property';
        themeForm.appendChild(hidden);
      }
    }, true); // capture phase — runs before Broadcast's handler
  })();

  /**
   * Fix: Broadcast scroll lock stuck after UpCart drawer closes 
   *
   * Root cause: When a product is added via quick-add modal, Broadcast fires
   * theme:product:added which simultaneously:
   *   1. Opens Broadcast's native cart drawer (adds .is-open, dispatches theme:scroll:lock)
   *   2. Closes the quick-add modal (which skips unlock because it sees the drawer as open)
   * Then UpCart intercepts and opens its own cart drawer on top. But UpCart never
   * calls Broadcast's closeCartDrawer(), so:
   *   - Broadcast's drawer keeps .is-open class forever
   *   - theme:scroll:unlock never fires
   *   - The FL3NKEY/scroll-lock vendor library's touchmove preventDefault stays active
   *   - On iOS, all touch scrolling is blocked (desktop unaffected — uses wheel events)
   *
   * Fix: Prevent Broadcast's cart drawer from opening when a product is added.
   * UpCart handles the cart drawer entirely — Broadcast's native drawer shouldn't
   * open at all. We intercept theme:product:added before Broadcast's listener
   * and stop its cart drawer from activating, then ensure scroll unlocks properly.
   */
  (function() {
    // Intercept theme:product:added BEFORE Broadcast's CartDrawer listener.
    // Use capture phase to run before Broadcast's bubble-phase listener.
    document.addEventListener('theme:product:added', function() {
      // After a short delay (to let Broadcast's openCartDrawer run synchronously
      // on the same event), force-close it so UpCart can take over cleanly.
      setTimeout(function() {
        var broadcastDrawer = document.querySelector('cart-drawer');
        if (broadcastDrawer && broadcastDrawer.classList.contains('is-open')) {
          // Use Broadcast's own closeCartDrawer which handles:
          // - Removing .is-open class
          // - Dispatching theme:cart-drawer:close
          // - Dispatching theme:scroll:unlock
          // - Removing focus trap
          if (typeof broadcastDrawer.closeCartDrawer === 'function') {
            broadcastDrawer.closeCartDrawer();
          } else {
            // Fallback: manually clean up if method not available
            broadcastDrawer.classList.remove('is-open');
            document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
          }
        }
      }, 50);
    });

    // Safety net: If scroll gets stuck for any reason, a touchstart on the page
    // when nothing is visibly open should force-unlock. This handles edge cases
    // where UpCart's close timing doesn't align with the above fix.
    document.addEventListener('touchstart', function() {
      if (!document.documentElement.hasAttribute('data-scroll-locked')) return;

      // Check if anything from Broadcast is legitimately open
      var hasOpenModals = document.querySelectorAll('dialog[open][data-scroll-lock-required]').length > 0;
      var hasOpenDrawers = document.querySelectorAll('.drawer.is-open').length > 0;

      // Check if UpCart's drawer is open (common UpCart selectors)
      var upcartOpen = document.querySelector('.upcart-visible, .upcart--open, [data-upcart][class*="open"], .upcart-side-cart--visible');

      if (!hasOpenModals && !hasOpenDrawers && !upcartOpen) {
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      }
    }, { passive: true });
  })();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
